import Product from './Product';
import check from '../libraries/check-types-ext';
export default class GridBlockElement {
    constructor(node, productMapper) {
        this.node = node;
        Object.assign(this, node);
        this.items = node.items.map((item) => {
            if ('objType' in item) {
                if (item.objType === 'InfoBlock' || item.objType === 'EmptySlot') {
                    return item;
                }
            }
            if (check.instance(item, Product)) {
                return item;
            }
            else {
                return productMapper.getProductObject(item);
            }
        });
    }
}
